// Pipeline stage metadata — single source of truth shared between the
// Pipeline kanban page, the Dispensary detail badge, and the edit dialog.
// Order here drives the column order on the kanban.

export const STAGES = [
  { value: "new",         label: "New",         color: "text-zinc-300",     bg: "bg-zinc-500/15",     border: "border-zinc-500/30",     bar: "bg-zinc-500" },
  { value: "prospecting", label: "Prospecting", color: "text-sky-300",      bg: "bg-sky-500/15",      border: "border-sky-500/30",      bar: "bg-sky-500" },
  { value: "contacted",   label: "Contacted",   color: "text-cyan-300",     bg: "bg-cyan-500/15",     border: "border-cyan-500/30",     bar: "bg-cyan-500" },
  { value: "demo_booked", label: "Demo Booked", color: "text-violet-300",   bg: "bg-violet-500/15",   border: "border-violet-500/30",   bar: "bg-violet-500" },
  { value: "sampling",    label: "Sampling",    color: "text-fuchsia-300",  bg: "bg-fuchsia-500/15",  border: "border-fuchsia-500/30",  bar: "bg-fuchsia-500" },
  { value: "active",      label: "Active",      color: "text-emerald-300",  bg: "bg-emerald-500/15",  border: "border-emerald-500/30",  bar: "bg-emerald-500" },
  { value: "lapsed",      label: "Lapsed",      color: "text-amber-300",    bg: "bg-amber-500/15",    border: "border-amber-500/30",    bar: "bg-amber-500" },
  { value: "lost",        label: "Lost",        color: "text-rose-300",     bg: "bg-rose-500/15",     border: "border-rose-500/30",     bar: "bg-rose-500" },
];

export const STAGE_BY_VALUE = Object.fromEntries(STAGES.map((s) => [s.value, s]));

export function stageMeta(value) {
  return STAGE_BY_VALUE[value] || STAGE_BY_VALUE.new;
}
